import React, { Fragment, useEffect, useRef, useState } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Row,
  Input,
} from "reactstrap";
import { Breadcrumbs, Btn, H3 } from "../../../AbstractElements";
import { useForm, Controller } from "react-hook-form";
import { useNavigate,useLocation } from "react-router-dom";
import {
  SubmitForm,
  Industry,
  IndustryError,
  AddCompany,
  FirstName,
  LastName,
  Email,
  Phone,
  Password,
  ConfirmPassword,
  FirstNameError,
  LastNameError,
  EmailError,
  CountryError,
  PasswordError,
  PhoneError,
  ConfirmPasswordError,
  Countrys,
} from "../../../Constant";
import { getIndustryData, addPackages, getTaxGroup, registerSub } from "../../../CommonURL";
import { postDataWithToken, getDataWithToken } from "../../../Utils/restUtils";
import Typeahead from "../../../CommonElements/TypeAhead";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';


const CompanyForm = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    getValues,
    trigger,
    setValue,
  } = useForm();
  const [industry, setIndustry] = useState([]);
  const [industryOption, setIndustryOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
const location = useLocation();

const enquiryData = location.state;
console.log("enquiryData",enquiryData);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };



  useEffect(() => {
    industryData();
  }, []);

  useEffect(() => {
    setIndustryOption(
      industry.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    );
  }, [industry]);
useEffect(() => {
  if (enquiryData) {
    // text fields
    setValue("firstName", enquiryData.userName || "");
    setValue("email", enquiryData.email || "");
    setValue("phone", enquiryData.mobile || "");
    setValue("country_code", enquiryData.country_code || "");
    setValue("country", enquiryData.country || "");

    // Country select
    const countryObj = Country.getAllCountries().find(
      (c) => c.name === enquiryData.country
    );

    if (countryObj) {
      setSelectedCountry(countryObj);
      setValue("country_code", countryObj.phonecode);
      setValue("country", countryObj.name);
      setValue("iso_code", countryObj.isoCode);
    }

    // Industry select
    const selectedIndustry = industryOption.find(
      (item) => item.label === enquiryData.industry_name
    );

    if (selectedIndustry) {
      setValue("industry", selectedIndustry);
    }
  }
}, [enquiryData, industryOption, setValue]);
  const industryData = async () => {
    const data = await getDataWithToken(getIndustryData);
    setIndustry(data.data);
  };

//   const goToCreateCompany = () => {
//   navigate(`${process.env.PUBLIC_URL}/subscriptions/create-company`);
// };
const onSubmit = async (data) => {
  setLoading(true);

  try {
    const requestBody = {
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      mobile: data.phone,
      password: data.password,
      confirm_password: data.confirm_pass,
      country: data.country?.name,
      state: data.state?.name,
      zip_code: data.zipcode,
      country: data.country,    
      country_code: data.country_code,
      iso_code: data.iso_code,
      industry_type_id: data.industry?.value,
    };

    const response = await postDataWithToken(registerSub, requestBody);
     
    if (response?.data?.status === true) {
      navigate(`${process.env.PUBLIC_URL}/subscriptions/create-company`,{ state: { bq_user_id: response.data?.data?.bq_user_id } });
    } else {
      alert("Registration failed. Try again.");
    }
  } catch (err) {
    console.error("Error submitting form:", err);
    alert("Something went wrong!");
  }

  setLoading(false);
};


  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs mainTitle="Add Subscriber" parent="Companies" title="Company" />
      <Card>
        <CardHeader className="pb-0">
          <H3>Add New Subscriber</H3>
          {/* <span>{CustomstyleText} <code className="text-danger">{novalidate}</code> {CustomstyleText2} <code className="text-danger">&lt;{form}&gt;</code>{CustomstyleText3}</span><span>{CustomstyleText4} <code className="text-danger">{invalid} </code> {and} <code className="text-danger">{valid} </code> {CustomstyleText5}</span> */}
        </CardHeader>
        <CardBody>
          <Form
           className="needs-validation"
           noValidate
           onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              <Col md="6">
                <Label className="form-label">{Industry}<span className="requireStar">*</span></Label>
                <Controller
                  name="industry"
                  control={control}
                  validate={(value) => (value ? undefined : IndustryError)}
                  render={({ field }) => (
                    <Typeahead
                      options={industryOption}
                      onChange={(value) => {
                        setValue("industry", value);
                        field.onChange(value); 
                      }}
                      value={field.value}
                    />
                  )}
                />
                <span className="text-danger">
                  {errors.industry && IndustryError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="first_name">
                  {FirstName}<span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="first_name"
                  type="text"
                  placeholder="First Name"
                  defaultValue={enquiryData?.userName || ""}
                  {...register("firstName", { required: true })}
                />
                <span className="text-danger">
                  {errors.firstName && FirstNameError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="last_name">
                  {LastName}<span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="last_name"
                  type="text"
                  defaultValue={enquiryData?.lastName || ""}
                  placeholder="Last Name"
                  {...register("lastName", { required: true })}
                />
                <span className="text-danger">
                  {errors.lastName && LastNameError}
                </span>
              </Col>
              <Col md="6">
                <Label className="form-label" for="email">
                  {Email}<span className="requireStar">*</span>
                </Label>
                <input
                  className="form-control"
                  id="email"
                  type="text"
                  defaultValue={enquiryData?.email || ""}
                  placeholder="Email"
                  {...register("email", { required: true })}
                />
                <span className="text-danger">
                  {errors.email && EmailError}
                </span>
              </Col>
              {/* COUNTRY */}
             <Col md="6">
  <Label className="form-label">
    {Countrys}<span className="requireStar">*</span>
  </Label>

  <Controller
    name="country_code"
    control={control}
    rules={{ required: "Country code is required" }}
    render={({ field }) => (
      <Select
        {...field}
        options={Country.getAllCountries()}
        getOptionLabel={(opt) => `${opt.name} (+${opt.phonecode})`}
        getOptionValue={(opt) => opt.phonecode}
        value={selectedCountry}
        onChange={(item) => {
          setSelectedCountry(item);
          setSelectedState(null);
          setSelectedCity(null);

          // Store only dial code — backend requires this
          setValue("country_code", item.phonecode);

          // Store full country name — backend also needs this
          setValue("country", item.name);
          setValue("iso_code", item.isoCode);
        }}
      />
    )}
  />

  <span className="text-danger">{errors.country_code?.message}</span>
</Col>


              {/* STATE */}
              <Col md="6">
                <Label className="form-label">State<span className="requireStar">*</span></Label>
                <Controller
                  name="state"
                  control={control}
                  rules={{ required: "State is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={State.getStatesOfCountry(
                        selectedCountry?.isoCode
                      )}
                      getOptionLabel={(opt) => opt.name}
                      getOptionValue={(opt) => opt.isoCode}
                      value={selectedState}
                      onChange={(item) => {
                        setSelectedState(item);
                        setSelectedCity(null);
                        setValue("state", item);
                      }}
                      isDisabled={!selectedCountry}
                    />
                  )}
                />
                <span className="text-danger">{errors.state?.message}</span>
              </Col>

              {/* CITY */}
              {/* <Col md="6">
    <Label className="form-label">City</Label>
    <Controller
        name="city"
        control={control}
        rules={{ required: "City is required" }}
        render={({ field }) => (
            <Select
                {...field}
                options={City.getCitiesOfState(selectedCountry?.isoCode, selectedState?.isoCode)}
                getOptionLabel={(opt) => opt.name}
                getOptionValue={(opt) => opt.name}
                value={selectedCity}
                onChange={(item) => {
                    setSelectedCity(item);
                    setValue("city", item);
                }}
                isDisabled={!selectedState}
            />
        )}
    />
    <span className="text-danger">{errors.city?.message}</span>
</Col> */}
              <Col md="6">
                <Label className="form-label" htmlFor="zipcode">
                  Zip/Pin code <span className="requireStar">*</span>
                </Label>

                <input
                  className="form-control"
                  type="text"
                  id="zipcode"
                  {...register("zipcode", {
                    required: "Zip/Pin code is required",
                  })}
                  placeholder="Zip/Pin code "
                />

                <span className="text-danger">{errors.zipcode?.message}</span>
              </Col>
              <Col md="6">
    <Label className="form-label">{Phone} <span className="requireStar">*</span></Label>

    <Controller
      name="phone"
      control={control}
      rules={{ required: "Phone number is required" }}
      render={({ field }) => (
        <PhoneInput
  {...field}
  country={"in"}
  value={field.value || ""}
  placeholder="Phone"
  enableSearch={true}
  onChange={(value, country) => {
    field.onChange(value);
    setValue("country_code", country.dialCode);
    setValue("country", country.name);
  }}
/>
      )}
    />

    <span className="text-danger">{errors.phone?.message}</span>
  </Col>
             <Col md="6">
  <FormGroup className="form-group2">
    <Label className="col-form-label">
      Password <span className="requireStar">*</span>
    </Label>

    <div className="position-relative">
     <Controller
  name="password"
  control={control}
  rules={{
    required: "Password is required",
    minLength: { value: 6, message: "Minimum 6 characters required" },
  }}
  render={({ field }) => (
    <div className="position-relative">
      <Input
        {...field}
        type={showPassword ? "text" : "password"}
        className="form-control"
        placeholder="Password"
      />

      <span
        className="position-absolute end-0 top-50 translate-middle-y me-3 text-primary"
        style={{ cursor: "pointer" }}
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? "hide" : "show"}
      </span>
    </div>
  )}
/>
    </div>

    <span className="text-danger">{errors.password?.message}</span>
  </FormGroup>
</Col>


{/* CONFIRM PASSWORD */} 
<Col md="6">
  <FormGroup className="form-group2">
    <Label className="col-form-label">
      Confirm Password <span className="requireStar">*</span>
    </Label>

    <div className="position-relative">
     <Controller
  name="confirm_pass"
  control={control}
  rules={{
    required: "Confirm Password is required",
    validate: (value) =>
      value === watch("password") || "Passwords do not match",
  }}
  render={({ field }) => (
    <div className="position-relative">
      <Input
        {...field}
        type={showConfirmPassword ? "text" : "password"}
        className="form-control"
        placeholder="Confirm password"
      />

      <span
        className="position-absolute end-0 top-50 translate-middle-y me-3 text-primary"
        style={{ cursor: "pointer" }}
        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
      >
        {showConfirmPassword ? "hide" : "show"}
      </span>
    </div>
  )}
/>

    </div>

    <span className="text-danger">{errors.confirm_pass?.message}</span>
  </FormGroup>
</Col>

            </Row>
            <FormGroup></FormGroup>
            <Btn  attrBtn={{ color: "primary" }} type="submit">
              {SubmitForm}
            </Btn>
          </Form>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default CompanyForm;
